export enum PomQueryKeys {
  // Agency
  GetAgencyCompanies = "GetAgencyCompanies",


  // Reportings
  GetReportingList = "GetReportingList",
  GetReporting = "GetReporting",
  SubmitReporting = "SubmitReporting",
  GetReportingHistory = "GetReportingHistory",
  GetReportingDraft = "GetReportingDraft",
  GetReportingDraftNos = "GetReportingDraftNos",
}
